import React, { useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { Box } from "@chakra-ui/react";
import { useTimelinePlayback, registerGsapPlugins } from "lib/gsap";
import { ScreenOneSvg } from "./screen-1-svg";

registerGsapPlugins(ScrollTrigger);

export function ScreenOneAnimation({ isActive }: { isActive: boolean }) {
  const ref = useRef<HTMLDivElement>(null);
  const timeline = useRef<gsap.core.Timeline>();

  useTimelinePlayback(timeline, isActive);

  useGSAP(
    () => {
      const animationConfig = {
        defaults: {
          duration: 2.5,
          ease: "power2.out",
          fillOpacity: 1,
          stagger: 0.007,
        },
        scrollTrigger: {
          trigger: "#aid-product-screen-1",
          onEnter: () => timeline.current?.restart(true),
          onLeave: () => timeline.current?.pause(),
          onEnterBack: () => timeline.current?.restart(true),
          onLeaveBack: () => timeline.current?.pause(),
        },
      };

      timeline.current = gsap
        .timeline(animationConfig)
        .to(".gray", { stagger: 0.005 }) // 10 cells
        .to(".electric-100", {}, "<") // 2 cells
        .to(".electric-200", {}, "-=2.38") // 1 cell
        .to(".electric-300", {}, "-=2.37") // 4 cells
        .to(".electric-500", {}, "-=2.36") // 4 cells
        .to(".electric-600", {}, "-=2.39") // 3 cells
        .to(".electric-700", {}, "-=2.36") // 4 cells
        .to(".electric-800", {}, "-=2.39") // 4 cells
        .to(".electric-900", {}, "-=2.39"); // 3 cells
    },
    { scope: ref },
  );

  return (
    <Box ref={ref} borderTopRadius="6px" overflow="hidden">
      <ScreenOneSvg id="aid-product-screen-1" />
    </Box>
  );
}
